module.exports = __webpack_public_path__ + "media/src/images/logo-069477898c4d66c0e1a8855589630ad8.png";